import { GroupState } from '@/composition/groups'
import { PostState } from '@/composition/posts'
import { SearchState } from '@/composition/search'
import { IPosts } from '@/models/Posts'

export function updatePostDataInStates(
  newPostData: IPosts,
  groupSlug?: string,
  channelSlug?: string
): void {
  if (newPostData._id) {
    // updating in search state if the post is present in search results
    const postIndex = SearchState.state.searchDiscussionResults?.findIndex(
      post => post._id === newPostData._id
    )
    if (postIndex !== -1) {
      copyAttributes(
        newPostData,
        SearchState.state.searchDiscussionResults[postIndex]
      )
    }
    // find post in the post list and update the current_user_reactions and reactions
    const post = PostState.state.posts?.find(
      post => post._id == newPostData._id
    )

    if (post) {
      copyAttributes(newPostData, post)
    }

    // check if the post is pinned in home timeline , if yes then update post data
    if (groupSlug) {
      const homeTimelinePinnedPost = PostState.state.pinnedPosts
        .get(groupSlug)
        ?.find(post => post._id == newPostData._id)

      if (homeTimelinePinnedPost) {
        copyAttributes(newPostData, homeTimelinePinnedPost)
      }
    }

    // check if the post is pinned in channel timeline , if yes then update the post data
    if (channelSlug) {
      const channelTimelinePinnedPost = PostState.state.pinnedPosts
        .get(channelSlug)
        ?.find(post => post._id == newPostData._id)
      if (channelTimelinePinnedPost) {
        copyAttributes(newPostData, channelTimelinePinnedPost)
      }
    }
  }
}

// need this function so that we only update the keys in the tagret object which are
// present in the source object, otherwise we could have used Object.assign() or spread operator
function copyAttributes(source: any, target: any) {
  for (const key in source) {
    target[key] = source[key]
      ? JSON.parse(JSON.stringify(source[key]))
      : undefined
  }
}

export function handlePostEdited(post: IPosts): void {
  const postRef = PostState.state.posts.find((p: IPosts) => p._id == post._id)

  // if post not found in post list then update the post data in states so
  // if may exists in pinned posts then it will be updated
  if (!postRef) {
    updatePostDataInStates(
      post,
      GroupState.state.groupData.slug,
      post.channelSlug
    )
    return
  }
  const outdatedPost = JSON.parse(JSON.stringify(postRef))
  if (outdatedPost) {
    outdatedPost.content = post.content
    outdatedPost.title = post.title
    outdatedPost.attachments = post.attachments
    outdatedPost.channelSlug = post.channelSlug
    outdatedPost.channelId = post.channelId
    outdatedPost.channelName = post.channelName
    outdatedPost.channelPinnedIndex = post.channelPinnedIndex
  }

  updatePostDataInStates(
    outdatedPost,
    GroupState.state.groupData.slug,
    outdatedPost.channelSlug
  )
}
